import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
const IconSizes = {
    xs: "h-4 w-4",
    sm: "h-5 w-5",
    md: "h-6 w-6",
    lg: "h-8 w-8",
    xl: "h-12 w-12",
    "2xl": "h-20 w-20",
};
export function Icon({ visual: IconComponent, size = "sm", className = "", }) {
    return IconComponent ? (React.createElement(IconComponent, { className: cn(className, "shrink-0", IconSizes[size]) })) : null;
}
const sizeVariants = cva("relative", {
    variants: {
        size: {
            sm: "h-5 w-5",
            md: "h-6 w-6",
            lg: "h-8 w-8 p-0.5",
            xl: "h-10 w-10",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});
const iconSizeVariants = cva("absolute", {
    variants: {
        size: {
            sm: "bottom-0 right-0",
            md: "bottom-0 right-0",
            lg: "bottom-0 right-0",
            xl: "bottom-0 right-0",
        },
    },
    defaultVariants: {
        size: "lg",
    },
});
export const DoubleIcon = ({ mainIcon, secondaryIcon, className, size = "lg", }) => {
    return (React.createElement("div", { className: cn(sizeVariants({ size }), className) },
        React.createElement(Icon, { className: "text-foreground", size: size === "sm"
                ? "xs"
                : size === "md"
                    ? "sm"
                    : size === "lg"
                        ? "md"
                        : "lg", visual: mainIcon }),
        React.createElement(Icon, { size: size === "sm"
                ? "xs"
                : size === "md"
                    ? "xs"
                    : size === "lg"
                        ? "xs"
                        : "md", visual: secondaryIcon, className: cn("absolute", iconSizeVariants({ size })) })));
};
//# sourceMappingURL=Icon.js.map